<template>
  <div class="dbg">
    <div class="dbg-left">
      <h1 class="dbg-h1">Bom dia, <span class="dbg-name">{{ firstName }}</span> <span class="dbg-emoji">👋</span></h1>
      <p v-if="hasRevenue24h" class="dbg-sub">
        Suas VSLs geraram <b>{{ revenueLast24h }}</b> em conversões nas últimas <b>24h</b>
        <template v-if="hasInsights"> · <b>{{ insightsCount }} insights</b> da IA esperando você.</template>
      </p>
      <p v-else-if="hasInsights" class="dbg-sub">
        <b>{{ insightsCount }} insights</b> da IA esperando você.
      </p>
    </div>
    <div class="dbg-periods">
      <button
        v-for="p in periods"
        :key="p.id"
        class="dbg-period"
        :class="{ on: period === p.id }"
        @click="$emit('period-change', p.id)"
      >{{ p.label }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashGreeting',
  props: {
    userName: { type: String, default: 'Eduardo' },
    period: { type: String, default: '7d' },
    revenueLast24h: { type: String, default: '' },
    insightsCount: { type: Number, default: 0 },
  },
  data() {
    return {
      periods: [
        { id: 'today',  label: 'Hoje' },
        { id: 'yesterday', label: 'Ontem' },
        { id: '7d',     label: '7 dias' },
        { id: '30d',    label: '30 dias' },
        { id: 'all',    label: 'Tudo' },
        { id: 'custom', label: 'Personalizado' },
      ],
    }
  },
  computed: {
    firstName() {
      return this.userName.split(' ')[0]
    },
    hasRevenue24h() {
      return !!this.revenueLast24h
    },
    hasInsights() {
      return Number(this.insightsCount) > 0
    },
  },
}
</script>

<style>
.dbg {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 18px;
  font-family: 'Inter', sans-serif;
  flex-wrap: wrap;
}
.dbg-h1 {
  font-size: 30px;
  font-weight: 900;
  letter-spacing: -.8px;
  color: var(--wr-text);
  margin: 0 0 6px;
  line-height: 1.1;
}
.dbg-name { color: var(--wr-text); }
.dbg-emoji { font-style: normal; }
.dbg-sub { font-size: 13.5px; color: var(--wr-mute); margin: 0; line-height: 1.5; }
.dbg-sub b { color: var(--wr-text); font-weight: 600; }
.dbg-periods {
  display: flex;
  gap: 4px;
  background: rgba(255,255,255,.04);
  border: 1px solid var(--wr-line-2);
  border-radius: 10px;
  padding: 4px;
  flex-shrink: 0;
  flex-wrap: wrap;
}
.dbg-period {
  padding: 6px 12px;
  border-radius: 7px;
  border: none;
  background: transparent;
  color: var(--wr-mute);
  font-size: 13px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: background .15s, color .15s;
  white-space: nowrap;
}
.dbg-period:hover { color: var(--wr-text); background: rgba(255,255,255,.06); }
.dbg-period.on { background: rgba(232,106,16,.15); color: #F08023; font-weight: 600; }
</style>
